import { ReactNode } from "react";

import { Stack, StackProps } from "@mantine/core";

import { TextWrapper } from "../TextWrapper";

import classes from "./FieldDisplay.module.css";

interface FieldDisplayProps extends StackProps {
  title: string;
  value: ReactNode;
}

export default function FieldDisplay({ title, value, ...props }: FieldDisplayProps) {
  return (
    <Stack gap="xs" {...props}>
      <TextWrapper variant="bold">{title}</TextWrapper>
      {/* `span`: `value` may be a block-level ReactNode (e.g. formatted HTML), which the browser
      would otherwise auto-close out of the default `<p>` element. As a direct child of this
      flex `Stack`, the element is blockified regardless of tag, so layout is unaffected. */}
      <TextWrapper span className={classes.fieldDisplayText}>
        {value}
      </TextWrapper>
    </Stack>
  );
}
